module.exports = __webpack_public_path__ + "img/PXL_20230524_174749567.0379f764.jpg";